import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        card: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(16),
            backgroundColor: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            padding: remCalc(16),
            color: 'text.default',
        },
        infoPopBox: {
            marginLeft: 'auto',
        },
        text: {textStyle: 'body-small'},
        infoIcon: {
            verticalAlign: 'middle',
            boxSize: 'iconsSize.small',
            cursor: 'pointer',
            color: 'text.default',
            // fill="button.text.secondary-default"
        },
    },
    parts: ['card', 'infoPopBox', 'text', 'infoIcon'],
}
